import React from "react";
import toast from "react-hot-toast";
import Toast from "../components/Toast";

export function showToast({ type = "info", message = "", actions, duration, onClose } = {}) {
  const hasRenderer = typeof actions === "function";
  const toastDuration = hasRenderer ? Infinity : duration ?? 4500;

  return toast.custom(
    (t) => (
      <Toast
        type={type}
        message={message}
        actions={hasRenderer ? actions(() => toast.dismiss(t.id)) : null}
        onClose={() => {
          toast.dismiss(t.id);
          if (onClose) onClose();
        }}
      />
    ),
    {
      duration: toastDuration,
      position: "top-right",
    }
  );
}
